import React, { useEffect, useState } from "react";

import ButtonWsp from "../ButtonWsp/ButtonWsp";
import "./Banner.scss";
import { useLocation } from "react-router-dom";

export const Banner = ({ children, customClass, background, styles }) => {
  return (
    <div className="banner-container--max banner-container-home--max">
      <div className="banner-back-mesh">
        <img
          style={styles}
          className="banner-back-mesh-img"
          src={background}
          alt=""
        />
      </div>
      <div className={`banner-container ${customClass}`}>
        <>
          {children}
          {/* <ButtonWsp /> */}
        </>
      </div>
    </div>
  );
};

export const Content = ({
  title,
  subtitle,
  footer,
  customClass,
  content,
  flag,
}) => {
  const { pathname } = useLocation();
  const [flagClass, setFlagClass] = useState("");

  useEffect(() => {
    if (pathname !== "/") {
      setFlagClass("flag-top");
    } else {
      setFlagClass("");
    }
  }, [pathname]);

  return (
    <div className={`content ${customClass}`}>
      {content}
      <div className="title">
        {flag && <span className={`title-flag ${flagClass}`}>{flag}</span>}
        <h1 dangerouslySetInnerHTML={{ __html: title }}></h1>
        <h3 dangerouslySetInnerHTML={{ __html: subtitle }} />
      </div>
      <div className="footer">{footer}</div>
    </div>
  );
};
